<template lang="html">
  <div>
    <b-modal ref="modal-terminos" centered hide-footer modal-class="modal-user-access-layout" @hide="$parent.openedModal = null;"title="Terminos y condiciones" >
      <div v-html="$root.extras.terminos">
      	
      </div>
      
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{


    }
  },

  methods: {
   
  },

  watch: {
    '$parent.openedModal': function (val, oldVal) {
      if(val == 'terminos'){
        this.$refs['modal-terminos'].show();
      }
    }
  },

  mounted(){

  },
}
</script>
